<template>
  <div class="page page--signup">
    <div class="section section--signup">
      <h2 class="section__title">Edit Account</h2>
      <div class="section__container">
        <div class="section__content">
          <div class="details">
            <form @submit.prevent="submit">
              <label for="email">Poshmark Email</label>
              <input class="input" id="email" v-model="form.email" type="email" />
              <label for="username">Poshmark Username</label>
              <input class="input" id="username" v-model="form.username" type="text" />
              <label for="password">Poshmark Password</label>
              <input class="input" id="password" v-model="form.password" type="password" />
              <input class="control" type="submit" value="Update Settings" />
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="section section--signup">
      <h2 class="section__title">Manage Subscription</h2>
      <div class="section__container">
        <div class="section__content">
          <div class="details">
            <h3>Payment Method</h3>
            <div
              class="card"
              v-if="paymentMethod"
            >{{paymentMethod.brand}} ending in {{paymentMethod.last4}}</div>
            <div class="card" v-else>No card on file</div>
            <a :href="billingPortalLink">Manage Billing</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      form: {
        username: '',
        email: '',
        password: '',
      },
      paymentMethod: null,
    };
  },
  computed: {
    billingPortalLink() {
      return this.$store.getters.billingPortalLink;
    },
  },
  methods: {
    async submit() {
      await this.$store.dispatch('updateUser', this.form);
      this.loading = false;
    },
  },
  async created() {
    const user = await this.$store.dispatch('fetchUser');
    this.form.username = user.poshmark_username;
    this.form.email = user.poshmark_email;
    this.paymentMethod = user.payment_method;
  },
};
</script>
